// js to switch variation and floorplan visible in related card / panel
// the pinch zoomer pulls element out into a fullscreen div separate from the original parent
// js to compensate for that and keep cards synced with the full screen versions when updated in either place

// favourites panel js to switch variants and visible favourites category also included here

window.addEventListener('load', event => {
    const homeDesignsCardPanel = document.querySelectorAll('.home-designs-card-panel');
    const homeDesignDisplayHeaderPanel = document.querySelector('.header-panel-feature-home, .header-panel-house-and-land');
    const favouritesPanel = document.querySelector('.favourites-panel');

    homeDesignsCardPanel.forEach((panel) => {
        panel.addEventListener('click', (event) => {
            const clickedElement = event.target;

            if (clickedElement.hasAttribute('data-toggle-variant')) {
                const parentCard = clickedElement.closest('[data-show-variant]');
                if (parentCard) {
                    const currentVariation = parentCard.dataset.showVariant;
                    const toggleVariant = clickedElement.dataset.toggleVariant;

                    if (toggleVariant !== currentVariation) {
                        parentCard.dataset.showVariant = toggleVariant;
                    }
                }
            }

            if (clickedElement.hasAttribute('data-toggle-floor')) {
                const parentCard = clickedElement.closest('[data-show-floor]');
                if (parentCard) {
                    const currentFloor = parentCard.dataset.showFloor;
                    const toggleFloor = clickedElement.dataset.toggleFloor;

                    if (toggleFloor !== currentFloor) {
                        parentCard.dataset.showFloor = toggleFloor;
                    }
                }
            }
        });
    });

    if (homeDesignDisplayHeaderPanel) {
        document.addEventListener('click', (event) => {
            const clickedElement = event.target;

            if (clickedElement.hasAttribute('data-toggle-variant')) {
                const fullScreenElement = document.querySelector('.fullscreenDiv');

                if (homeDesignDisplayHeaderPanel.hasAttribute('data-show-variant')) {
                    const unfilteredMatchingElements = [fullScreenElement, homeDesignDisplayHeaderPanel, ...homeDesignDisplayHeaderPanel.querySelectorAll('[data-show-variant]')];
                    const matchingElements = unfilteredMatchingElements.filter(element => element !== null);

                    const currentVariation = homeDesignDisplayHeaderPanel.dataset.showVariant;
                    const toggleVariant = clickedElement.dataset.toggleVariant;

                    if (toggleVariant !== currentVariation) {
                        matchingElements.forEach((element) => {
                            element.dataset.showVariant = toggleVariant;
                        });
                    }

                    // update dropdown text to match active variant
                    // shift matching variant to top of dropdown list
                    const variantSelectorDropdown = homeDesignDisplayHeaderPanel.querySelector('[data-variant-selector]').closest('div');
                    const allRelatedButtons = variantSelectorDropdown?.querySelectorAll('button');

                    if (allRelatedButtons.length) {
                        allRelatedButtons.forEach((button) => {
                            if (button.dataset.toggleVariant === toggleVariant) {
                                button.classList.add('order-first');
                                const buttonInnerText = button.querySelector('span')?.innerText;
                                variantSelectorDropdown.querySelector('option').innerText = buttonInnerText;
                            } else {
                                button.classList.remove('order-first');
                            }
                        });
                    }
                }
            }

            if (clickedElement.hasAttribute('data-toggle-floor')) {
                const fullScreenElement = document.querySelector('.fullscreenDiv');

                if (homeDesignDisplayHeaderPanel.hasAttribute('data-show-floor')) {
                    const unfilteredMatchingElements = [fullScreenElement, homeDesignDisplayHeaderPanel, ...homeDesignDisplayHeaderPanel.querySelectorAll('[data-show-floor]')];
                    const matchingElements = unfilteredMatchingElements.filter(element => element !== null);

                    const currentFloor = homeDesignDisplayHeaderPanel.dataset.showFloor;
                    const toggleFloor = clickedElement.dataset.toggleFloor;

                    if (toggleFloor !== currentFloor) {
                        matchingElements.forEach((element) => {
                            element.dataset.showFloor = toggleFloor;
                        });
                    }
                }
            }
        });
    }

    if (favouritesPanel) {
        const categoryButtons = favouritesPanel.querySelectorAll('button[data-category]');

        document.addEventListener('click', (event) => {
            const clickedElement = event.target;

            //category switching
            if (clickedElement.hasAttribute('data-category')) {
                favouritesPanel.dataset.showingCategory = clickedElement.dataset.category;

                categoryButtons.forEach((button) => {
                    button.dataset.active = 'false';
                })
                clickedElement.dataset.active = 'true';
            }

            const parentElement = clickedElement.closest('[data-home-designs-card-extended]');
            const parentShowFloor = parentElement ? parentElement : clickedElement.closest('[data-show-floor]');
            const parentShowVariant = parentElement ? parentElement : clickedElement.closest('[data-show-variant]');

            if (clickedElement.hasAttribute('data-toggle-variant')) {
                const fullScreenElement = document.querySelector('.fullscreenDiv');

                if (parentShowVariant) {
                    let unfilteredMatchingElements = [fullScreenElement, parentShowVariant, ...parentShowVariant.querySelectorAll('[data-show-variant]')];

                    if (parentShowVariant.dataset.belongsToCard) {
                        const cardParent = document.querySelector(`[data-home-designs-card-extended="${parentShowVariant.dataset.belongsToCard}"]`);
                        unfilteredMatchingElements = [fullScreenElement, cardParent, ...cardParent.querySelectorAll('[data-show-variant]')];
                    }
                    const matchingElements = unfilteredMatchingElements.filter(element => element !== null);

                    const currentVariation = parentShowVariant.dataset.showVariant;
                    const toggleVariant = clickedElement.dataset.toggleVariant;

                    if (toggleVariant !== currentVariation) {
                        matchingElements.forEach((element) => {
                            element.dataset.showVariant = toggleVariant;
                        });
                    }

                    // update dropdown text to match clicked element
                    const selectorParent = clickedElement.closest('.group\\/title');
                    const buttonInnerText = clickedElement.querySelector('span')?.innerText;
                    if (selectorParent && buttonInnerText) {
                        selectorParent.querySelector('option').innerText = buttonInnerText;
                    }

                    // shift clicked element to top of dropdown list
                    const allRelatedButtons = clickedElement.closest('div').querySelectorAll('button');
                    if (allRelatedButtons.length) {
                        allRelatedButtons.forEach((button) => {
                            button.classList.remove('order-first');
                        });
                        clickedElement.classList.add('order-first');
                    }
                }
            }

            if (clickedElement.hasAttribute('data-toggle-floor')) {
                const fullScreenElement = document.querySelector('.fullscreenDiv');

                if (parentShowFloor) {
                    let unfilteredMatchingElements = [fullScreenElement, parentShowFloor, ...parentShowFloor.querySelectorAll('[data-show-floor]')];

                    if (parentShowFloor.dataset.belongsToCard) {
                        const cardParent = document.querySelector(`[data-home-designs-card-extended="${parentShowFloor.dataset.belongsToCard}"]`);
                        unfilteredMatchingElements = [fullScreenElement, cardParent, ...cardParent.querySelectorAll('[data-show-variant]')];
                    }
                    const matchingElements = unfilteredMatchingElements.filter(element => element !== null);

                    const currentFloor = parentShowFloor.dataset.showFloor;
                    const toggleFloor = clickedElement.dataset.toggleFloor;

                    if (toggleFloor !== currentFloor) {
                        matchingElements.forEach((element) => {
                            element.dataset.showFloor = toggleFloor;
                        });
                    }
                }
            }
        });
    }
});